import { Component } from '@angular/core';
import { ProjectStatus } from '../../../models/project';
import { Subject } from 'rxjs/Subject';
import { OptionService } from '../../../shared/option.service';
import { FormControl } from '@angular/forms';
import { ClrDatagridFilterInterface, DatagridFilter } from '@clr/angular';

@Component({
  selector: 'cw-status-filter',
  templateUrl: './status-filter.component.html',
})
export class StatusFilterComponent implements ClrDatagridFilterInterface<ProjectStatus> {
  availableStatuses: { value: string; label: any }[];
  statusCtrl: FormControl;
  changes = new Subject<any>();
  value: [ProjectStatus];
  statuses: ProjectStatus[] = [];

  constructor(private filterContainer: DatagridFilter,
              private optionService: OptionService) {
    filterContainer.setFilter(this);
    this.availableStatuses = this.optionService.projectStatusOptions;
    this.statusCtrl = new FormControl();
    this.statusCtrl.valueChanges.subscribe(status => {
      this.changes.next(status);
      this.value = [status];
    })
  }


  isActive(): boolean {
    return this.statuses.length > 0;
  }

  accepts(status: ProjectStatus) {
    console.log(status);
    return true;
  }

  setStatus(value: ProjectStatus, checked: boolean) {
    let idx = this.statuses.findIndex(s => value === s);

    if (!checked && idx > -1) {
      this.statuses.splice(idx, 1);
    } else {
      this.statuses.push(value);
    }
    this.changes.next(true);
  }

  isChecked(value: ProjectStatus): boolean {
    return this.statuses.findIndex(s => value === s) > -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/list/status-filter/status-filter.component.ts